export default __webpack_public_path__ + "assets/marker-icon-2x.680f69f3.png";